import type {StyleRuleObject} from "../../../stem-core/ui/Style";
import {ProgressBarStyle} from "../../../stem-core/ui/ProgressBar";
import {styleRuleInherit} from "../../../stem-core/decorators/Style";

export class DashboardProgressBarStyle extends ProgressBarStyle {
    @styleRuleInherit
    container: StyleRuleObject = {
        height: 6,
        marginTop: 6,
        marginBottom: 6,
        borderRadius: this.themeProps.CARD_BORDER_RADIUS,
        boxShadow: null,
    }
}
